import { apiGetCard, type BackendCard, cardUpdated } from '@shared-core/features/backend'
import { useAppDispatch } from '@shared-core/store'
import { useEffect, useState } from 'react'

// Данных, которых нет в общем списке карт: баланс, маска номера, адрес. Ответ привязан к cardId,
// поэтому при смене карты старые данные не показываются.
export function useCardDetails(cardId?: string): BackendCard | null {
  const dispatch = useAppDispatch()
  const [loaded, setLoaded] = useState<{ cardId: string; card: BackendCard } | null>(null)

  useEffect(() => {
    if (!cardId) return

    let active = true

    void apiGetCard({ routeParams: { id: cardId } }).then((response) => {
      if (!active || response?.status !== 'ok' || !response.data) return

      setLoaded({ cardId, card: response.data })
      dispatch(cardUpdated({ id: cardId, status: response.data.status }))
    })

    return () => {
      active = false
    }
  }, [cardId, dispatch])

  return loaded && loaded.cardId === cardId ? loaded.card : null
}
